import type { TableQuery } from "owa-mail-list-store";
import { action } from "satcheljs";

export interface NeedsReplyViewCloseRequestedMessage {
    previousTableQuery: TableQuery;
}

const defaultExport: (previousTableQuery: TableQuery) => NeedsReplyViewCloseRequestedMessage = action("NEEDS_REPLY_VIEW_CLOSE_REQUESTED", (previousTableQuery: TableQuery): NeedsReplyViewCloseRequestedMessage => ({
    previousTableQuery,
}));
export default defaultExport;
